module.exports = __webpack_public_path__ + "img/1.0dd6cdd3.png";